const TURNKEY_API_BASE_URL = 'https://api.turnkey.com';

export { TURNKEY_API_BASE_URL };
